import { render, staticRenderFns } from "./WorkspaceProjectsCard.vue?vue&type=template&id=1ff543bb&"
import script from "./WorkspaceProjectsCard.vue?vue&type=script&lang=js&"
export * from "./WorkspaceProjectsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports